<template>
  <el-dialog
    title="修改名称"
    :visible="true"
    :append-to-body="true"
    width="300px"
    :before-close="handleClose"
  >
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
      <el-form-item prop="name">
        <el-input v-model="ruleForm.name" :maxlength="10" show-word-limit></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "EditColumn",
  props: ["title"],
  data() {
    return {
      ruleForm: {
        name: ""
      },
      rules: {
        name: [
          { required: true, message: '内容不能为空', trigger: 'blur' },
        ],
      }
    }
  },
  created() {
    this.ruleForm.name = this.title;
  },
  methods: {
    handleClose() {
      this.$emit("handleClose");
    },
    handleConfirm() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          const title = this.ruleForm.name;
          this.$emit("handleConfirm", title);
        }
      });
    }
  }
}
</script>

<style>

</style>